export enum AVAILABLE_ACTIONS {
  unlink,
  configure,
  edit,
  link,
}
